import isEmptyArray from './isEmptyArray';

// ----------------------------------------------------------------------------

function isEmptyArrayFor(...args: unknown[]): boolean {
    return args.every((item): any => isEmptyArray(item));
}

// ----------------------------------------------------------------------------

export default isEmptyArrayFor;
